<template>
  <section class="ass">
    <div class="ass__glow ass__glow--blue" aria-hidden="true"></div>
    <div class="ass__dots" aria-hidden="true"></div>

    <div class="ass__container">
      <div class="ass__head reveal">
        <p class="ass__eyebrow">Assuraf</p>
        <h2 class="ass__title">{{ $t('home_page.nos_assurances[0]') }}</h2>
        <span class="ass__bar"></span>
      </div>

      <div class="ass__switch reveal">
        <button
          type="button"
          class="ass__tab"
          :class="{ 'is-active': person }"
          @click="switchDevis('person')"
        >
          {{ $t('home_page.person_devis_label') }}
        </button>
        <button
          type="button"
          class="ass__tab"
          :class="{ 'is-active': moral }"
          @click="switchDevis('moral')"
        >
          {{ $t('home_page.moral_devis_label') }}
        </button>
      </div>

      <div v-if="person" class="ass__grid">
        <article class="ass__card reveal" @click="toDevisAuto()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/cars_quote.png" alt="devis auto" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[1]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisHabitation()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/house_quote.png" alt="devis habitation" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[2]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisVoyage()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/travel_quote.png" alt="devis voyage" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[3]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisSante()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/health_quote.png" alt="devis santé" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[4]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisVie()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/life_quote.png" alt="devis vie" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[5]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisAssurPlus()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/add_quote.png" alt="devis assur plus" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[6]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>
      </div>

      <div v-if="moral" class="ass__grid">
        <article class="ass__card reveal" @click="toIndividuAccident()">
          <span class="ass__icon">
            <img src="../../../assets/img/home/new_home/individual_accident_button.png" alt="devis individuel accident" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[12]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisMrp()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/mrp_quote.png" alt="devis mrp" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[7]') }} {{ $t('home_page.nos_assurances[8]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisTrc()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/trc_quote.png" alt="devis trc" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[9]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisAssurcare()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/health_quote.png" alt="devis assurcare" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[4]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toCaution()">
          <span class="ass__icon">
            <img src="../../../assets/img/home/new_home/caution_button.png" alt="devis caution" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[10]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>

        <article class="ass__card reveal" @click="toDevisFlotte()">
          <span class="ass__icon">
            <img src="../../../assets/img/icones/menu/flotte_quote.png" alt="devis flotte" loading="lazy" />
          </span>
          <h3 class="ass__card-title">{{ $t('home_page.nos_assurances[11]') }}</h3>
          <i class="fas fa-arrow-right ass__arrow"></i>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'assurance_section',
  data: () => ({
    disabledAccessFlotte: false,
    person: true,
    moral: false,
    choiceType: 'person',
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    switchDevis(type) {
      this.choiceType = type;
      this.person = type === 'person';
      this.moral = type === 'moral';
    },

    toDevisAuto() {
      let url = '/devis/auto'
      this.$router.push(url)
    },
    toDevisHabitation() {
      let url = '/devis/habitation'
      this.$router.push(url)
    },
    toDevisVoyage() {
      let url = '/devis/voyage'
      this.$router.push(url)
    },
    toDevisSante() {
      let url = '/devis/sante'
      this.$router.push(url)
    },
    toDevisVie() {
      let url = '/devis/vie'
      this.$router.push(url)
    },
    toDevisAssurPlus() {
      let url = '/plus'
      this.$router.push(url)
    },
    toCaution() {
      let url = "/devis/sonac/caution"
      this.$router.push(url)
    },
    toDevisMrp() {
      let url = "/devis/mrp"
      this.$router.push(url)
    },
    toDevisTrc() {
      let url = "/devis/trc"
      this.$router.push(url)
    },
    toIndividuAccident() {
      let url = "/individuel"
      this.$router.push(url)
    },

    toDevisAssurcare() {
      let url = "/devis/sante/assurcare"
      this.$router.push(url)
    },

    toDevisFlotte() {
      let url = "/flotte/entreprise"
      this.$router.push(url)
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.ass {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #fff 0%, #FFFBF6 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.4;
    pointer-events: none;

    &--blue {
      width: 460px;
      height: 460px;
      background: rgba(91, 148, 188, 0.28);
      top: -160px;
      left: -120px;
    }
  }

  &__dots {
    position: absolute;
    bottom: 6%;
    right: 4%;
    width: 120px;
    height: 120px;
    background-image: radial-gradient(rgba(255, 164, 9, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 44px;
  }

  &__eyebrow {
    display: inline-block;
    background: rgba(91, 148, 188, 0.14);
    color: #3d7ba6;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 999px;
    margin: 0 0 18px;
  }

  &__title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 18px;
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__switch {
    display: flex;
    justify-content: center;
    gap: 6px;
    width: max-content;
    margin: 0 auto 44px;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.08);
    border-radius: 999px;
    padding: 6px;
    box-shadow: 0 12px 30px rgba(43, 43, 43, 0.07);
  }

  &__tab {
    border: none;
    cursor: pointer;
    background: transparent;
    padding: 12px 30px;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 700;
    color: #59595b;
    transition: all 0.25s ease;

    &.is-active {
      background: linear-gradient(135deg, #ffb33d 0%, #ffa409 55%, #f57c00 100%);
      color: #fff;
      box-shadow: 0 8px 20px rgba(255, 164, 9, 0.35);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  &__card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 18px;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 22px;
    padding: 24px;
    box-shadow: 0 14px 36px rgba(43, 43, 43, 0.07);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.35s cubic-bezier(0.22, 0.61, 0.36, 1),
      box-shadow 0.35s ease, border-color 0.35s ease;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      background: linear-gradient(90deg, #ffa409, #f57c00);
      opacity: 0;
      transition: opacity 0.35s ease;
    }

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(255, 164, 9, 0.4);
      box-shadow: 0 24px 50px rgba(240, 136, 0, 0.16);

      &::before {
        opacity: 1;
      }

      .ass__arrow {
        transform: translateX(4px);
        color: #f57c00;
      }
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    border-radius: 18px;
    flex-shrink: 0;
    background: #fff3df;

    img {
      width: 34px;
      height: 34px;
      object-fit: contain;
    }
  }

  &__card:nth-child(even) .ass__icon {
    background: #eaf3f9;
  }

  &__card-title {
    flex: 1;
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
    color: #2b2b2b;
  }

  &__arrow {
    color: #ffa409;
    font-size: 14px;
    transition: transform 0.25s ease, color 0.25s ease;
  }
}

@media (max-width: 991px) {
  .ass {
    padding: 72px 24px;

    &__grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 18px;
    }

    &__title {
      font-size: 32px;
    }
  }
}

@media (max-width: 600px) {
  .ass {
    padding: 56px 20px;

    &__switch {
      width: 100%;
    }

    &__tab {
      flex: 1;
      padding: 12px 16px;
    }

    &__card {
      gap: 14px;
      padding: 18px 16px;
    }

    &__icon {
      width: 54px;
      height: 54px;
      border-radius: 16px;

      img {
        width: 30px;
        height: 30px;
      }
    }

    &__card-title {
      font-size: 14px;
    }
  }
}

</style>
